import React from 'react';
import { Skeleton, Card } from 'antd';

const MetaSetupSkeleton: React.FC = () => {
    return (
        <div className="p-6 max-w-7xl mx-auto space-y-8">
            {/* Header Card Skeleton */}
            <Card className="shadow-sm">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div className="w-full sm:w-2/3">
                        <Skeleton active title={{ width: '40%' }} paragraph={{ rows: 1, width: '80%' }} />
                    </div>
                    <div className="w-full sm:w-auto">
                        <Skeleton.Button active size="large" className="w-full sm:w-40" />
                    </div>
                </div>
            </Card>

            {/* Search Filters Skeleton */}
            <Card className="shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Skeleton.Input active block />
                    <Skeleton.Input active block />
                    <Skeleton.Input active block />
                </div>
            </Card>

            {/* Data Grid Skeleton */}
            <Card className="shadow-md p-4 rounded-2xl">
                <div className="grid md:grid-cols-3 gap-6">
                    {[1, 2, 3].map((col) => (
                        <div key={col} className="flex flex-col" style={{ minHeight: '400px' }}>
                            <div className="mb-4">
                                <Skeleton active title={{ width: '60%' }} paragraph={false} />
                            </div>
                            <div className="space-y-2">
                                {[1, 2, 3, 4, 5].map((row) => (
                                    <div key={row} className="flex items-center gap-2 p-2.5 border border-gray-100 rounded-lg">
                                        <Skeleton.Avatar active size="small" />
                                        <div className="flex-1">
                                            <Skeleton active title={{ width: '70%' }} paragraph={{ rows: 1, width: '40%' }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-auto pt-4 flex justify-center">
                                <Skeleton.Input active size="small" style={{ width: 100 }} />
                            </div>
                        </div>
                    ))}
                </div>
            </Card>

            {/* Sync Button Skeleton */}
            <div className="text-center">
                <Skeleton.Button active size="large" style={{ width: 200 }} />
            </div>
        </div>
    );
};

export default MetaSetupSkeleton;
